// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--KMVKp","icon":"_7a3fb80146--icon--BhtQE","text":"_7a3fb80146--text--uFe9M"};